let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7upe4")).then(() => parcelRequire('cHdJi'));